export default __webpack_public_path__ + "static/media/close-circle.59ab9b69.svg";